import React from 'react';

export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid rgba(10,158,143,0.13)', padding: '1.75rem 2.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.9rem', background: '#060606', textAlign: 'center' }}>
      <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
        <img src="/dialspark-wordmark-dark.svg" alt="DialSpark" width="101" height="24" style={{ display: 'block', height: 24, width: 'auto' }} />
      </a>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.75rem 1.25rem', fontSize: '0.72rem', fontFamily: "'JetBrains Mono', monospace" }}>
        <a href="/privacy-policy" style={{ color: '#a0a0a0' }}>Privacy Policy</a>
        <a href="/terms-of-service" style={{ color: '#a0a0a0' }}>Terms of Service</a>
        <a href="/data-deletion" style={{ color: '#a0a0a0' }}>Data Deletion</a>
      </div>
      <div style={{ fontSize: '0.72rem', color: '#f0f0f0', fontFamily: "'JetBrains Mono', monospace" }}>© 2026 DialSpark. All rights reserved.</div>
      <div style={{ fontSize: '0.72rem', color: '#555555', fontFamily: "'JetBrains Mono', monospace" }}>DialSpark is operated by Utgone Telecom Private Limited.</div>
    </footer>
  );
}
